import React, { useState, useEffect, useRef } from "react";
import FullLoading from "../../../../components/full-loading3";
import PopupBottomModal from "../../../../components/popup-bottom-modal";
import ImageView from "../../../../components/image-view";
import "./index.less";
import Toast from "@xpeng/rc-toast";
import PopupModelCenter, {
  PopupModelProps
} from "../../../../components/popup-model-center";
import { useHistory } from "react-router-dom";
import { bindCard, getUserInfo, openAccountBindCard } from "../../api";
import { getCurrentUid } from "../../../../api/web-h5-common";
import ContactService from "../../../../components/contact-service";
import { isByteLengthInRange } from "../../../../utils/common";
import { trackGdp } from "../../../../utils/gio-report";

const income = () => {
  const router = useHistory();
  const [uid, setUid] = useState("");
  const [status, setStatus] = useState(0); // 用户开户状态
  const [userName, setUserName] = useState(""); // 用户名
  const [userIdNo, setUserIdNo] = useState(""); // 用户证件号码
  const [userPhone, setUserPhone] = useState(""); //  申请注册的用户的手机号，个人用户必填
  const [bankAccount, setBankAccount] = useState(""); // 银行卡账号

  const [userNameError, setUserNameError] = useState(false);
  const [userIdNoError, setUserIdNoError] = useState(false);
  const [bankAccountError, setBankAccountError] = useState(false);
  const [userPhoneError, setUserPhoneError] = useState(false);

  const [agreement, setAgreement] = useState(false);
  const [centerVisible, setCenterVisible] = useState(false); // 中部弹窗
  const [bottomVisible, setBottomVisible] = useState(false); // 底部弹窗
  const [popupModelData, setPopupModelData] = useState<PopupModelProps>({});
  const imgList = [
    "https://s.xiaopeng.com/xp-charge/mini/sharing/amount_tips_1.png",
    "https://s.xiaopeng.com/xp-charge/mini/sharing/amount_tips_2.png",
    "https://s.xiaopeng.com/xp-charge/mini/sharing/amount_tips_3.png"
  ];
  useEffect(() => {
    document.title = "提现银行卡绑定";
    trackGdp("P20145", "B001");
    getUserInfo({}).then(res => {
      setStatus(res.data.status);
    });
    getCurrentUid().then(res => {
      console.log("getCurrentUid", res);
      if (res) {
        setUid(res);
        console.log(
          "localStorage",
          localStorage.getItem(`BindCardData_${res}`)
        );
        const data = localStorage.getItem(`BindCardData_${res}`);
        if (data) {
          const dataObj = JSON.parse(data);
          setUserName(dataObj.userName);
          setUserIdNo(dataObj.userIdNo);
          setUserPhone(dataObj.userPhone);
          setBankAccount(dataObj.bankAccount);
        }
      }
    });
  }, []);

  // 绑卡失败
  const bindCardFail = res => {
    const failMsg = res?.msg || "";
    trackGdp("P20145", "B004");
    setCenterVisible(true);
    setPopupModelData({
      popupTitle: "绑卡失败",
      content: <div style={{fontFamily: "PingFang SC"}}>很抱歉，绑卡失败了，失败原因：{failMsg}</div>,
      leftBtnText: <ContactService><div style={{color: 'rgba(0, 0, 0, 0.9)'}}>咨询客服</div></ContactService>,
      leftBtnFun: () => {
        setCenterVisible(false);
      },
      rightBtnText: "好的",
      rightBtnFun: () => {
        setCenterVisible(false);
      }
    });
  };

  // 查看协议
  const showInstructions = () => {
    window.location.href =
      "https://events.xiaopeng.com/y31mfz.html?ch=04474&ps=event";
  };

  // 绑定
  const onfirm = () => {
    trackGdp("P20145", "B003");
    // 将表单数据存入缓存
    localStorage.setItem(
      `BindCardData_${uid}`,
      JSON.stringify({ userName, userIdNo, userPhone, bankAccount })
    );
    console.log("agreement", agreement);
    if (checkAll()) {
      Toast.show("录入所有信息后可绑定");
      return;
    }
    if (!agreement) {
      setCenterVisible(true);
      setPopupModelData({
        popupTitle: "温馨提示",
        content: (
          <div>
            同意
            <span style={{ color: "#5A960A" }} onClick={showInstructions}>
              《中国银联个人用户绑卡授权同意书》
            </span>
          </div>
        ),
        leftBtnText: "不同意",
        leftBtnFun: () => {
          setCenterVisible(false);
        },
        rightBtnText: "同意",
        rightBtnFun: () => {
          setCenterVisible(false);
          setAgreement(true);
          doComfirm();
        }
      });
    } else {
      doComfirm();
    }
  };

  const doComfirm = () => {
    FullLoading.show({
      text: "请稍后"
    });
    const apiFun = status ? bindCard : openAccountBindCard;
    // 提交数据要去除空格
    apiFun({
      userName: userName.replace(/\s+/g, ""),
      userIdNo: userIdNo.replace(/\s+/g, ""),
      bankAccount: bankAccount.replace(/\s+/g, ""),
      userPhone: userPhone.replace(/\s+/g, "")
    })
      .then(res => {
        if ([0, 200].includes(res.code)) {
          router.replace("/manage-card");
        } else {
          bindCardFail(res);
        }
      })
      .finally(() => {
        FullLoading.hide();
      });
  };
  // 表单全校验
  const checkAll = () => {
    return (
      checkUserName() ||
      checkUserIdNo() ||
      checkUserPhone() ||
      checkBankAccount()
    );
  };

  // 校验用户名
  const checkUserName = (setErrorStatus: boolean = false) => {
    console.log("checkUserName");
    // 用户名字节数长度为（3，18】
    if (!isByteLengthInRange(userName, 3, 18)) {
      // setUserNameError(true);
    } else if (userName[0] === " " || userName[userName.length - 1] === " ") {
      // setUserNameError(true);
    } else if (!/^[\u4e00-\u9fa5a-zA-Z·, ]*$/.test(userName)){ // 允许输入中文、英文、特殊字符，特殊字符仅包括"·"、空格、半角逗号
      // setUserNameError(true);
    } else {
      setErrorStatus && setUserNameError(false);
      return false;
    }
    setErrorStatus && setUserNameError(true);
    return true;
  };

  // 校验身份证号
  const checkUserIdNo = (setErrorStatus: boolean = false) => {
    if (userIdNo.length !== 18) {
      // setUserIdNoError(true);
    } else if (userIdNo.includes(" ")) {
      // setUserIdNoError(true);
    } else if (userIdNo.toUpperCase() !== userIdNo) {
      // setUserIdNoError(true);
    } else if (!/^[0-9a-zA-Z]*$/.test(userIdNo)) {
      // setUserIdNoError(true);
    } else {
      setErrorStatus && setUserIdNoError(false);
      return false;
    }
    setErrorStatus && setUserIdNoError(true);
    return true;
  };

  // 校验手机号
  const checkUserPhone = (setErrorStatus: boolean = false) => {
    if (!/^1[3456789]\d{9}$/.test(userPhone)) {
      setErrorStatus && setUserPhoneError(true);
      return true;
    } else {
      setErrorStatus && setUserPhoneError(false);
      return false;
    }
  };

  // 校验银行卡号
  const checkBankAccount = (setErrorStatus: boolean = false) => {
    if (!/^\d{12,20}$/.test(bankAccount)) {
      setErrorStatus && setBankAccountError(true);
      return true;
    } else {
      setErrorStatus && setBankAccountError(false);
      return false;
    }
  };

  return (
    <div className="bind-card-content">
      <div>
        <div className="input-item-padding">
          <div className="input-item" style={{ padding: 0, flex: 1 }}>
            <div className="input-label">持卡人</div>
            <input
              className="input"
              type="text"
              placeholder="请输入持卡人姓名"
              value={userName}
              onChange={e => {
                setUserName(e.target.value);
              }}
              onBlur={e => {
                checkUserName(true);
              }}
            />
          </div>
          {userNameError && <div className="error">请输入正确的姓名</div>}
        </div>

        <div className="input-item-padding">
          <div className="input-item" style={{ padding: 0, flex: 1 }}>
            <div className="input-label">身份证号</div>
            <input
              className="input"
              type="text"
              placeholder="请输入身份证号"
              value={userIdNo}
              onChange={e => {
                // 超过18个输入无效
                if (e.target.value.length > 18) {
                  return;
                }
                setUserIdNo(e.target.value);
              }}
              onBlur={e => {
                checkUserIdNo(true);
              }}
            />
          </div>
          {userIdNoError && <div className="error">请输入正确的身份证号</div>}
        </div>

        <div className="input-item-padding">
          <div className="input-item" style={{ padding: 0, flex: 1 }}>
            <div className="input-label">银行预留手机号</div>
            <input
              className="input"
              type="number"
              inputMode="numeric"
              placeholder="请输入手机号"
              value={userPhone}
              onChange={e => {
                // 超过11个输入无效
                if (e.target.value.length > 11) {
                  return;
                }
                // 输入须为数字
                if (!/^\d*$/.test(e.target.value)) {
                  return;
                }
                setUserPhone(e.target.value);
              }}
              onBlur={e => {
                checkUserPhone(true);
              }}
            />
          </div>
          {userPhoneError && <div className="error">请输入正确的手机号</div>}
        </div>

        <div className="input-item-padding">
          <div className="input-item" style={{ padding: 0, flex: 1 }}>
            <div className="input-label" onClick={() => setBottomVisible(true)}>
              银行卡号
              <img
                src={
                  "https://s.xiaopeng.com/xp-charge/mini/common/grey_guide.png"
                }
                alt=""
              />
            </div>
            <input
              className="input"
              type="number"
              inputMode="numeric"
              placeholder="请输入借记卡卡号"
              value={bankAccount}
              onChange={e => {
                // 输入须为纯数字
                if (!/^\d*$/.test(e.target.value)) {
                  return;
                }
                // 超过20个输入无效
                if (e.target.value.length > 20) {
                  return;
                }
                setBankAccount(e.target.value);
              }}
              onBlur={e => {
                checkBankAccount(true);
              }}
            />
          </div>
          <div className="tips" style={{ marginTop: 8 }}>
            仅支持绑定个人借记卡
          </div>
          {bankAccountError && (
            <div className="error">请输入正确的银行卡号</div>
          )}
        </div>
        <div className="tips explain">
          <div>1. 根据监管部门要求，提现需补充个人身份证件信息</div>
          <div style={{ color: "#5A960A" }}>2. 姓名、身份证号认证通过后不可修改，请慎重填写</div>
        </div>
      </div>
      <div>
        <div className="agreement-item">
          {agreement ? (
            <img
              src="https://s.xiaopeng.com/xp-charge/mini/card-pack/check-node-green.png"
              onClick={() => setAgreement(!agreement)}
              alt=""
            />
          ) : (
            <img
              src="https://s.xiaopeng.com/xp-charge/mini/card-pack/check-node-grey.png"
              onClick={() => {
                setAgreement(!agreement);
                trackGdp("P20145", "B002");
              }}
              alt=""
            />
          )}
          <div>我已阅读并同意</div>
          <div style={{ color: "#5A960A" }} onClick={showInstructions}>
            《中国银联个人用户绑卡授权同意书》
          </div>
        </div>
        <div className="btn-item" onClick={onfirm}>
          <div
            className="btn"
            style={{
              backgroundColor:
                agreement && !checkAll() ? "#181916" : "rgb(197,197,197)"
            }}
          >
            绑定
          </div>
        </div>
      </div>

      <PopupModelCenter
        visible={centerVisible}
        popupTitle={popupModelData.popupTitle}
        content={popupModelData.content}
        leftBtnText={popupModelData.leftBtnText}
        rightBtnText={popupModelData.rightBtnText}
        leftBtnFun={popupModelData.leftBtnFun}
        rightBtnFun={popupModelData.rightBtnFun}
      />

      <PopupBottomModal
        title="如何查询银行卡卡号"
        visible={bottomVisible}
        pageClassName='bind-card-content'
        onClose={() => setBottomVisible(false)}
      >
        <div className="popupModel">
          <div className="text">
            线上查询：打开相关银行APP，进入我的账户 - 银行卡列表 -
            （银行卡详情页），可查询并复制银行卡号
          </div>
          <div className="img-list">
            {imgList.map((item, index) => {
              return <ImageView key={index} url={item} />;
            })}
          </div>
          <div className="btn-bottom-item" onClick={() => setBottomVisible(false)}>
            <div className="btn">
              好的
            </div>
        </div>
        </div>
      </PopupBottomModal>
    </div>
  );
};
export default income;
